/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const DigitalMarketingApp: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path d="M11.8148 8.10172H4.13484C3.62584 8.10172 3.13684 8.30372 2.77684 8.66372C2.41684 9.02372 2.21484 9.51172 2.21484 10.0217V13.8617C2.21484 14.3707 2.41684 14.8597 2.77684 15.2197C3.13684 15.5797 3.62484 15.7817 4.13484 15.7817H5.09484V19.6217C5.09484 19.8767 5.19584 20.1207 5.37584 20.3007C5.55584 20.4807 5.79984 20.5817 6.05484 20.5817H7.97484C8.22984 20.5817 8.47384 20.4807 8.65384 20.3007C8.83384 20.1207 8.93484 19.8767 8.93484 19.6217V15.7817H11.8148L16.6148 19.6217V4.26172L11.8148 8.10172V8.10172ZM14.6948 15.3977L12.7748 13.8617H4.13484V10.0217H12.7748L14.6948 8.48572V15.3977ZM20.9348 11.9417C20.9348 13.5837 20.0128 15.0717 18.5348 15.7817V8.10172C20.0038 8.82172 20.9348 10.3097 20.9348 11.9417Z" />

    </StyledIconBase>
  )
})

DigitalMarketingApp.displayName = 'DigitalMarketingApp'

export const DigitalMarketingAppDimensions = {height: 24, width: 24}
